import type { TableColumns } from '@ohpen/enso-ui';
import { FieldType, IntermediaryGetAll } from '@pmp/api';

export const assistantsColumns: TableColumns<IntermediaryGetAll[]> = [
  {
    title: 'lender.brokers.labels.name',
    dataIndex: 'displayName',
    key: 'displayName',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  // TODO: collaboration field not available in new IntermediaryGetAll type
  {
    title: 'lender.brokers.labels.roles',
    dataIndex: 'roles',
    key: 'roles',
    options: {
      filter: 'select',
      format: {
        type: 'multiValueListKey',
      },
      listName: FieldType.USER_ROLE_TYPE,
    },
  },
  {
    title: 'lender.brokers.labels.contacts',
    dataIndex: 'email',
    key: 'email',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
];
